import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import PrimaryCare from './PrimaryCare';

export default function Blog() {
  return (
    <>
        <Navbar />
        <PrimaryCare />
        <Footer />
        <Copyright />
    </>
  )
}